/* Footer sütunları mobilde akordeon; masaüstünde her zaman açık.

   Açık/kapalı durumu sütunun kendisinde (.ks-footer__col.is-open) tutuluyor:
   buton bir <h2> içinde, liste ise <h2>'nin kardeşi — yani butondan komşu
   seçiciyle listeye ulaşılamıyor. */
(function () {
  'use strict';

  const mq = window.matchMedia('(max-width: 860px)');
  const toggles = Array.from(document.querySelectorAll('.ks-footer__col-toggle'));
  if (!toggles.length) return;

  function sync() {
    const collapsible = mq.matches;
    toggles.forEach((toggle) => {
      const open = collapsible ? toggle.dataset.wasOpen === 'true' : true;
      toggle.setAttribute('aria-expanded', String(open));
      setOpen(toggle, open);
    });
  }

  function setOpen(toggle, open) {
    const column = toggle.closest('.ks-footer__col');
    if (column) column.classList.toggle('is-open', open);
  }

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      if (!mq.matches) return;
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      toggle.dataset.wasOpen = String(open);
      setOpen(toggle, open);
    });
  });

  mq.addEventListener('change', sync);
  sync();
})();

/* "Çerez Tercihleri" bağlantısı.

   Shopify'ın çerez bannerı açıksa sayfaya `window.privacyBanner` ekleniyor
   ve `showPreferences()` tercih penceresini yeniden açıyor. Betik
   content_for_header ile geç yükleniyor; bu yüzden bir süre bekleniyor.
   Banner hiç gelmezse bağlantı gizli kalıyor — tıklanıp bir şey olmayan
   bir düğme göstermek yanıltıcı olurdu. */
(function () {
  'use strict';

  const holder = document.querySelector('[data-cookie-prefs]');
  if (!holder) return;
  const button = holder.querySelector('button');

  function ready() {
    return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
  }

  function reveal() {
    holder.hidden = false;
    button.addEventListener('click', () => {
      try { window.privacyBanner.showPreferences(); } catch (error) { /* banner kaldırıldıysa sessiz kal */ }
    });
  }

  let tries = 0;
  (function wait() {
    if (ready()) { reveal(); return; }
    if (++tries > 20) return; // ~10 sn
    window.setTimeout(wait, 500);
  })();
})();
